import { REMOVABLE_NAMESPACE_PATTERN } from '@cli-constants/patterns.js'

export function normalizeNamespaceForRemoval(value: unknown): string | undefined {
  if (typeof value !== 'string') {
    return
  }

  const segment = value.trim()
  return REMOVABLE_NAMESPACE_PATTERN.test(segment) ? segment : undefined
}
